import {
  EditOutlined,
  //SaveOutlined
} from "@ant-design/icons";
import { Input, Modal, Form, Spin, notification, Button } from "antd";
import { Row, Col } from "reactstrap";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

import CancelAction from "../../Tools/CancelAction";
import { useAuth } from "../../context/auth";

const ActionModalName = ({ visibleName, onCancel, onOk }) => {
  const { accessToken, user } = useAuth()
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const [changed, setChange] = useState(false);
  const [openModalCancelAction, setOpenModalCancelAction] = useState(false);

  const save = async (values) => {
    const url = new URL('/api/user/self', window.location);

    const res = await fetch(url, {
      method: 'PATCH',
      headers: { 'X-ACCESS-TOKEN': accessToken },
      body: JSON.stringify({
        firstName: values.userName,
        lastName: values.surName,
      }),
    })
    if (res.ok) {
      Swal.fire({
        icon: "success",
        title: "Success !",
        text: "Successfully saved data.",
        showConfirmButton: false,
        timer: 1500,
      });
      onOk();
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    form.setFieldsValue({
      userName: user.firstName,
      surName: user.lastName,
    });
  });
  useEffect(() => {
    setHideNav(window.innerWidth <= 1000);
  }, []);

  return (
    <>
      <Modal
        open={visibleName}
        title={
          <div className="flex items-center">
            <EditOutlined />
            &nbsp;&nbsp;
            <span>Change name - surname</span>
          </div>
        }
        width={hideNav ? "85%" : "50%"}
        onCancel={() => {
          if (changed) {
            setOpenModalCancelAction(true);
          } else {
            setOpenModalCancelAction(false);
            onCancel();
          }
        }}
        footer={
          <div className="w-full text-center mb-4 flex justify-center">
            <Button
              className="w-36"
              type="primary"
              ghost
              key="cancel"
              shape="round"
              onClick={() => {
                if (changed) {
                  setOpenModalCancelAction(true);
                } else {
                  setOpenModalCancelAction(false);
                  onCancel();
                }
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                form.validateFields().then((values) => {
                  save(values);
                });
              }}
              className="w-36"
              key="save"
              type="primary"
              shape="round"
              loading={loading}
            >
              Save
            </Button>
          </div>
        }
      >
        <Spin spinning={loading} tip="Loading...">
          <Form
            onFieldsChange={(_, allFields) => {
              if (allFields.length > 0) {
                setChange(true);
              }
            }}
            form={form}
            //name="charger-management"
            //className="price"
            layout="vertical"
          >
            <Row>
              <Col lg="6">
                <Form.Item label="Name" colon={false} name="userName">
                  <Input placeholder="Name" maxLength={50} allowClear />
                </Form.Item>
              </Col>
              <Col lg="6">
                <Form.Item label="Surname" colon={false} name="surName">
                  <Input placeholder="Surname" maxLength={50} allowClear />
                </Form.Item>
              </Col>
            </Row>

            <Row></Row>
          </Form>
        </Spin>
      </Modal>

      <CancelAction
        openModalCancelAction={openModalCancelAction}
        onOk={() => {
          setChange(false);
          onCancel();
        }}
        onCancel={() => {
          setOpenModalCancelAction(false);
        }}
      />
    </>
  );
};

export default ActionModalName;
